import Bugsnag from "@bugsnag/js";
import { capworksProgramService } from "@/modules/capworks/store/services/capworks-program-service";
import { LENDING_PROGRAM_SERVICE_TAG } from "@/features/LendingProgram/utils/lendingProgramServiceTags";
import { LIST_SERVICE_TAG } from "@/shared/store/service/commonServiceTags";
import { DEFAULT_NOTIFICATION_PAYLOAD, NOTIFICATION_VARIANTS } from "@/utils/applicationConstants";
import { ANALYTIC_EVENTS, sendAnalytics } from "@/utils/analytics";
import { showNotification } from "@/redux/actions/notification";
import { lenderHubDealService } from "@/features/LenderHub/Deal/store/services/lenderHubDealService";

const deleteLendingProgramDetailEndpoint = capworksProgramService.injectEndpoints({
  endpoints: (builder) => ({
    deleteLendingProgramDetail: builder.mutation({
      query: ({ lendingProgramId, parameterType, parameterId }) => ({
        url: `lending-programs/${lendingProgramId}/types/${parameterType}/parameters/${parameterId}`,
        method: "DELETE",
      }),
      invalidatesTags: () => [
        { type: LENDING_PROGRAM_SERVICE_TAG, id: LIST_SERVICE_TAG },
      ],
      async onQueryStarted(
        { lendingProgramId, parameterType, parameterId },
        { dispatch, queryFulfilled, getState },
      ) {
        const state = getState();
        const queries = capworksProgramService.util.selectCachedArgsForQuery(state, "getLendingProgramDetails");
        const patchResults = [];

        queries.forEach((queryArgs) => {
          if (queryArgs.lendingProgramId === lendingProgramId && queryArgs.parameterType === parameterType) {
            const patchResult = dispatch(
              capworksProgramService.util.updateQueryData("getLendingProgramDetails", queryArgs, (draft) => {
                const parameter = draft.find((p) => p.parameterId === parameterId);
                if (parameter) parameter.isActive = false;
              }),
            );
            patchResults.push(patchResult);
          }
        });

        try {
          const { data } = await queryFulfilled;
          sendAnalytics(ANALYTIC_EVENTS.LENDING_PROGRAM_PARAMETER_REMOVED, data);
          dispatch(
            showNotification({
              ...DEFAULT_NOTIFICATION_PAYLOAD,
              message: {
                ...DEFAULT_NOTIFICATION_PAYLOAD.message,
                description: `${data.parameterName} has been removed from the program!`,
                options: { variant: NOTIFICATION_VARIANTS.SUCCESS },
              },
            }),
          );
          dispatch(lenderHubDealService.util.invalidateTags(["LenderHubDeal"]));
        } catch (err) {
          patchResults.forEach((patchResult) => patchResult.undo());
          Bugsnag.notify(err);
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useDeleteLendingProgramDetailMutation } = deleteLendingProgramDetailEndpoint;

